<template>
  <div id="page-report">
  <div class="row">
    <div class="col-12">
      
      <router-link to="/dashboard" tag="button" class="back-home">Back to Home</router-link>
      <card>
        <div slot="raw-content" class="table-responsive">
          <div class="row" id="top-tool-bar">
            <div class="col-12">
              <h4>Sales Report</h4>
              <select v-model="select_by" @change="generate" id="selected_by">
                <option value="">Select Sales</option>
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
                <option value="yearly">Yearly</option>
              </select>
            </div>
            
          </div>

          <table class="table table-striped" id="transact-tbl" v-if="select_by==''">
          <tbody>
            <tr>
               <td align="center" colspan="3" id="no-record">Please select reports</td>
             </tr>
                                           
          </tbody>
          
        </table>

          <div class="selected_by_wrap" v-show="selected_daily">
            <loader v-if="loader"/>
                  <table class="table table-striped" id="transact-tbl">
                      <thead >
                          <th>Transaction Date</th>
                          <th>Total Sales</th>
                      </thead>
          <tbody v-if="transactions.total > 0">
                                            <tr v-for="(transact,index) in transactions.data" :key="index">
                                                <td>{{ transact.transaction_date}}</td>
                                                <td>{{ transact.total_sales.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td align="center" colspan="2" id="no-record">No record found.</td>
                                            </tr>
          </tbody>
          
        </table>

                <paginate
                    :page-count="total_page"
                    :page-range="1"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    v-if="transactions.total > 0"
                    >
                  </paginate>
                  

          </div>



          <div class="selected_by_wrap" v-show="selected_weekly">
            <loader v-if="loader"/>
                  <table class="table table-striped" id="transact-tbl">
                      <thead >
                          <th>Week Number</th> 
                          <th>Total Sales</th>
                      </thead>
          <tbody v-if="transactions.total > 0">
                                            <tr v-for="(transact,index) in transactions.data" :key="index">
                                                <td>{{ transact.week_number}}</td>
                                                <td>{{ transact.total_sales.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td align="center" colspan="2" id="no-record">No record found.</td>
                                            </tr>
          </tbody>
          
        </table>

                <paginate
                    :page-count="total_page"
                    :page-range="1"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    v-if="transactions.total > 0"
                    >
                  </paginate>
                  

          </div>


          <div class="selected_by_wrap" v-show="selected_monthly">
            <loader v-if="loader"/>
                  <table class="table table-striped" id="transact-tbl">
                      <thead >
                          <th>Month</th>
                          <th>Total Sales</th>
                      </thead>
          <tbody v-if="transactions.total > 0">
                                            <tr v-for="(transact,index) in transactions.data" :key="index">
                                                <td>{{ transact.month}}</td>
                                                <td>{{ transact.total_sales.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
                                              
                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td align="center" colspan="2" id="no-record">No record found.</td>
                                            </tr>
          </tbody>
          
        </table>

                <paginate
                    :page-count="total_page"
                    :page-range="1"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    v-if="transactions.total > 0"
                    >
                  </paginate>
                  

          </div>


          <div class="selected_by_wrap" v-show="selected_yearly">
            <loader v-if="loader"/>
                  <table class="table table-striped" id="transact-tbl">
                      <thead >
                          <th>Year</th>
                          <th>Total Sales</th>
                      </thead>
          <tbody v-if="transactions.total > 0">
                                            <tr v-for="(transact,index) in transactions.data" :key="index">
                                                <td>{{ transact.year}}</td>
                                                <td>{{ transact.total_sales.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
                                              
                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td align="center" colspan="2" id="no-record">No record found.</td>
                                            </tr>
          </tbody>
          
        </table>

                <paginate
                    :page-count="total_page"
                    :page-range="1"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    v-if="transactions.total > 0"
                    >
                  </paginate>
                  

          </div>
          
        </div>
      </card>
    </div>
  </div>


  </div>
</template>
<script>
import api  from "@/static/config.json";
import axios from 'axios'
import Loader from "@/components/Loader";
import Modal from '@/components/Modal';
import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  components:{
    Loader,
    Paginate,
    Modal,
    DatePicker
  },
  data() {
    return {
      loader: false,
      total_page: 0,
      transactions:[],
      total_sales: 0,
      cash:0,
      gcash:0,
      select_by:'',
      selected_daily:false,
      selected_weekly:false,
      selected_monthly:false,
      selected_yearly:false
    }
  },
  methods:{
    async list(page=1){
           let self = this;
           let limit=10;

         
           
           let selected = this.select_by;
           self.page = page;
           self.loader = true;

                await axios.get(api.API_URL+`/report/get-sales?page=${page}&limit=${limit}&selected=${selected}`,
                  {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                  }
                ).then(({data})=>{
                  self.loader = false;
                  self.transactions = data
                  self.total_page = Math.ceil(data.total/limit);

                }).catch(({ response })=>{
                  if(response.data.error.code =='token_could_not_verified'){
                              localStorage.removeItem("token");
                              this.$router.push('/login')
                  }
                })
     },

     clickCallback (pageNum){
        console.log(pageNum)
        this.list(pageNum)
    },
    notifyVue(verticalAlign, horizontalAlign,type,msg,icon) {
      const color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        title:msg,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
    generate(){
        this.list()
        if(this.select_by=='daily'){
            this.selected_daily = true;
            this.selected_weekly = false;
            this.selected_monthly = false;
            this.selected_yearly = false;
        }else if(this.select_by=='weekly'){
            this.selected_daily = false;
            this.selected_weekly = true;
            this.selected_monthly = false;
            this.selected_yearly = false;
        }else if(this.select_by=='monthly'){
            this.selected_daily = false;
            this.selected_weekly = false;
            this.selected_monthly = true;
            this.selected_yearly = false;
        }else if(this.select_by=='yearly'){
            this.selected_daily = false;
            this.selected_weekly = false;
            this.selected_monthly = false;
            this.selected_yearly = true;
        }else{
            this.selected_daily = false;
            this.selected_weekly = false;
            this.selected_monthly = false;
            this.selected_yearly = false;
        }
    },
    getDate(){
      const today = new Date();
      const yyyy = today.getFullYear();
      let mm = today.getMonth() + 1; // Months start at 0!
      let dd = today.getDate();

      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;

      const formattedToday = mm + '/' + dd + '/' + yyyy;
      return formattedToday;
    },
    getTime(){
      const today = new Date();
      const formattedTime = today.toLocaleTimeString().replace(/:\d+ /, ' ');
      return formattedTime;
    }
  },
  created() {
    
  }
};
</script>
<style>
#transact-tbl .btn{padding: 5px 10px!important; margin-right:5px;}
.action{text-align: center;}
#top-tool-bar{padding:10px;}
#add-transact{float:right;}
#search{width:50%;}
.pagination li{margin-right:20px;}
.pagination{padding: 10px!important;}
.pagination .page-item.active a{font-weight: bold; background-color: #b6aa62!important;} 
.pagination li a{background: #028f8f; padding: 5px; color: #fff!important; }
#add-transact{float:right;}
#no-record{font-weight: bold; font-size: 20px;}
.client-name{margin-left: 10px;}
#page-report .modal{overflow-y: scroll!important;    height: 560px;}
.trash-service{margin-left: 10px;}
#grand-total{float:right;}
.add-services{margin-top:30px;}
.cash-label{font-weight: bold; font-size: 22px; margin-right: 10px;}
#client-notes{width:100%;}
#generate{margin-left: 10px;}
.report-text-head{padding-left: 16px; font-size: 16px;}
.back-home{margin-bottom: 20px; background: #028f8f; color:#fff; border:none;}
.total-wrap{margin-left:10px; margin-bottom: 30px;}
.total-wrap h4{margin-top: 0px!important;}
#selected_by{padding: 10px;}
</style>
